// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"187":"ca8f2fb8","9884":"ca8f2fb8"}[chunkId] + ".css";
};